// extracted by mini-css-extract-plugin
export default {"results":"SearchResults_results__UcSa0"};